import React, { useContext } from "react";
import classes from "./Header.module.css";
import { SlLocationPin } from "react-icons/sl";
import { BsSearch } from "react-icons/bs";
import { BiCart } from "react-icons/bi";
import LowerHeader from "./LowerHeader";
import { Link, useNavigate } from "react-router-dom";
import { DataContext } from "../DataProvider/DataProvider";
import { auth } from "../../Components/Utility/firebase";

const Header = () => {
  const { user, basket } = useContext(DataContext);
  const navigate = useNavigate();

  const totalItems =
    basket?.reduce((total, item) => total + item.amount, 0) || 0;

  const handleSignOut = () => {
    auth.signOut().then(() => {
      navigate("/auth");
    });
  };

  return (
    <section className={classes.fixed}>
      <div className={classes.header__container}>
        {/* LOGO */}
        <div className={classes.logo__container}>
          <Link to="/">
            <img
              src="https://pngimg.com/uploads/amazon/amazon_PNG25.png"
              alt="Amazon Logo"
            />
          </Link>

          <div className={classes.delivery}>
            <span>
              <SlLocationPin />
            </span>
            <div className={classes.delivery}>
              <p>Deliver to</p>
              <span>PA, USA</span>
            </div>
          </div>
        </div>

        {/* SEARCH */}
        <div className={classes.search}>
          <select>
            <option>All</option>
          </select>
          <input type="text" placeholder="Search products..." />
          <BsSearch size={37} />
        </div>

        {/* RIGHT SECTION */}
        <div className={classes.order__container}>
          {/* LANGUAGE */}
          <div className={classes.language}>
            <img
              src="https://pngimg.com/uploads/flags/small/flags_PNG14655.png"
              alt="USA Flag"
            />
            <select>
              <option>EN</option>
            </select>
          </div>

          {/* USER SIGN-IN / SIGN-OUT */}
          <div className={classes.userSection}>
            {user ? (
              <div className={classes.userInfo}>
                <p>Hello {user.email.split("@")[0]}</p>
                <button className={classes.signOutBtn} onClick={handleSignOut}>
                  Sign Out
                </button>
              </div>
            ) : (
              <Link to="/auth">
                <div className={classes.userInfo}>
                  <p>Hello, Sign In</p>
                  <span>Account & Lists</span>
                </div>
              </Link>
            )}
          </div>

          {/* ORDERS */}
          <Link to="/orders" className={classes.orders}>
            <p>Returns</p>
            <span>& Orders</span>
          </Link>

          {/* CART */}
          <Link to="/cart" className={classes.cart}>
            <BiCart size={35} />
            <span className={classes.cartCount}>{totalItems}</span>
          </Link>
        </div>
      </div>

      <LowerHeader />
    </section>
  );
};

export default Header;
